import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/da.ts
var add = "Tilføj";
var remove = "Fjern";
var removeAll = "Fjern alle";
var incomplete = "Alle felter er ikke korrekt udfyldt.";
var submit = "Send";
var noFiles = "Ingen filer valgt";
var moveUp = "Flyt op";
var moveDown = "Flyt ned";
var isLoading = "Indlæser...";
var loadMore = "Indlæs mere";
var next = "Næste";
var prev = "Forrige";
var addAllValues = "Tilføj alle værdier";
var addSelectedValues = "Tilføj valgte værdier";
var removeAllValues = "Fjern alle værdier";
var removeSelectedValues = "Fjern valgte værdier";
var chooseDate = "Vælg dato";
var changeDate = "Skift dato";
var close = "Luk";
var open = "Åbn";
var accepted = function({
  name
}) {
  return `Accepter venligst ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} skal være senere end ${date(args[0])}.`;
  }
  return `${sentence(name)} skal være i fremtiden.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} kan kun indeholde bogstaver.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} kan kun indeholde bogstaver og tal.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} kan kun indeholde bogstaver og mellemrum.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} skal indeholde alfabetiske tegn.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} skal indeholde bogstaver eller tal.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} skal indeholde bogstaver eller mellemrum.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} skal indeholde symbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} skal indeholde store bogstaver.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} skal indeholde små bogstaver.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} skal indeholde tal.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} skal være et symbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} kan kun indeholde store bogstaver.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} kan kun indeholde små bogstaver.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} skal være før ${date(args[0])}.`;
  }
  return `${sentence(name)} skal være før i dag.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Dette felt er ikke konfigureret korrekt og kan derfor ikke blive sendt.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} skal være mellem ${a} og ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} matcher ikke.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} er ikke gyldig, brug venligst formatet ${args[0]}`;
  }
  return "Dette felt er ikke konfigureret korrekt og kan derfor ikke blive sendt.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} skal være mellem ${date(args[0])} og ${date(args[1])}`;
};
var email = "Indtast venligst en gyldig email-adresse.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} slutter ikke med ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} er ikke en gyldig værdi.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} skal være på mindst ét tegn.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} skal være på højst ${max2} tegn.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} skal være ${max2} tegn lange.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} skal være på mindst ${min2} tegn.`;
  }
  return `${sentence(name)} skal være på mindst ${min2} og højst ${max2} tegn.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} er ikke en gyldig værdi.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Kan ikke have flere end ${args[0]} ${name}.`;
  }
  return `${sentence(name)} skal være mindre eller lig med ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Ingen filformater tilladt.";
  }
  return `${sentence(name)} skal være af filtypen: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Kan ikke have mindre end ${args[0]} ${name}.`;
  }
  return `${sentence(name)} skal være mindst ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” er ikke en tilladt ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} skal være et tal.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" eller ")} er påkrævet.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} er påkrævet.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} starter ikke med ${list(args)}.`;
};
var url = function() {
  return `Indtast en gyldig URL.`;
};
var invalidDate = "Den valgte dato er ugyldig.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var da_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, da_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=da.mjs.map